import React from "react";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

const OverrideDeleteDialog = ({ open, onOpenChange, handleDeleteRequest }) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("planning.overridesPanel.deleteTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("planning.overridesPanel.deleteDescription")}
          </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t("planning.scheduleManager.actions.cancel")}</AlertDialogCancel>
        <AlertDialogAction onClick={handleDeleteRequest} className="bg-red-500 hover:bg-red-600">
          {t("planning.scheduleManager.actions.delete")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  );
};

export default OverrideDeleteDialog;
